import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { AuthComponent } from './auth.component';
import { CheckAuthenticatedService } from './api-services/check-authenticated.service';

/**
 * コープデリ職員認証検証画面 モジュール設定クラス
 *
 * @export AuthModule
 * @class AuthModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    AuthComponent,
  ],
  providers: [
    CheckAuthenticatedService,
  ]
})
export class AuthModule {

}
